/**
 * FlippersTile - Collectible powerup that allows swimming in water
 */

import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";

export class FlippersTile extends BaseTile {
  constructor({ col, row, id }: { col: number; row: number; id?: string }) {
    super(id ?? `flippers-${col}-${row}`, col, row);
  }

  tileType(): TileIndex {
    return TILE.FLIPPERS;
  }

  textureDescriptor(): TextureDescriptor {
    return { type: "png", path: "tiles/flippers.png" };
  }

  clone(): FlippersTile {
    const copy = new FlippersTile({ col: this.col, row: this.row, id: this.id });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return { type: "flippers", id: this.id, col: this.col, row: this.row };
  }
}
